var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 5.5C18.25 5.91421 18.5858 6.25 19 6.25C19.4142 6.25 19.75 5.91421 19.75 5.5H18.25ZM14.5 0.25C14.0858 0.25 13.75 0.585786 13.75 1C13.75 1.41421 14.0858 1.75 14.5 1.75V0.25ZM1.75 14.5C1.75 14.0858 1.41421 13.75 1 13.75C0.585786 13.75 0.25 14.0858 0.25 14.5H1.75ZM5.5 19.75C5.91421 19.75 6.25 19.4142 6.25 19C6.25 18.5858 5.91421 18.25 5.5 18.25V19.75ZM5.5 1.75C5.91421 1.75 6.25 1.41421 6.25 1C6.25 0.585787 5.91421 0.25 5.5 0.25V1.75ZM0.25 5.5C0.25 5.91421 0.585786 6.25 1 6.25C1.41421 6.25 1.75 5.91421 1.75 5.5H0.25ZM14.5 18.25C14.0858 18.25 13.75 18.5858 13.75 19C13.75 19.4142 14.0858 19.75 14.5 19.75V18.25ZM19.75 14.5C19.75 14.0858 19.4142 13.75 19 13.75C18.5858 13.75 18.25 14.0858 18.25 14.5H19.75ZM19.75 5.5C19.75 2.6005 17.3995 0.25 14.5 0.25V1.75C16.5711 1.75 18.25 3.42893 18.25 5.5H19.75ZM0.25 14.5C0.25 17.3995 2.6005 19.75 5.5 19.75V18.25C3.42893 18.25 1.75 16.5711 1.75 14.5H0.25ZM5.5 0.25C2.60051 0.25 0.25 2.6005 0.25 5.5H1.75C1.75 3.42893 3.42893 1.75 5.5 1.75V0.25ZM14.5 19.75C17.3995 19.75 19.75 17.3995 19.75 14.5H18.25C18.25 16.5711 16.5711 18.25 14.5 18.25V19.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitViewIcon);
export default __webpack_public_path__ + "static/media/fitViewIcon.fff0b201242ede8a8f525af432388396.svg";
export { ForwardRef as ReactComponent };